import { render, staticRenderFns } from "./ParametrosFornecedorDetalhes.vue?vue&type=template&id=aba76ff4&scoped=true&lang=pug"
import script from "./ParametrosFornecedorDetalhes.vue?vue&type=script&lang=js"
export * from "./ParametrosFornecedorDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ParametrosFornecedorDetalhes.vue?vue&type=style&index=0&id=aba76ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba76ff4",
  null
  
)

export default component.exports